import { Component, OnInit } from '@angular/core';
import { RegisterInforService } from '@pg-app/auth/services/register-infor.service';
import { RegisterStep1Service } from '@pg-app/auth/services/register-step-1.service';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent {
  isPrivalgoMarkets = environment.isPrivalgoMarkets;
  brandName = environment.brandName;
  constructor(public registerInfo: RegisterInforService, private registerStep1Service: RegisterStep1Service) { }

  onSubmit() {
    const emailNotArrive = {
      email: this.registerInfo.email,
      clientId: this.registerInfo.clientId
    };
    this.registerStep1Service.emailNotArrive(emailNotArrive).subscribe();
  }
}
